import {
  Calculator,
  Page404,
  SubscriptionPage,
  SubscriptionsPage,
} from '@/components/pages'
import {
  Navigate,
  RouterProvider as ReactRouterProvider,
  createBrowserRouter,
} from 'react-router-dom'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to={'subscriptions'} />,
  },
  {
    path: 'subscriptions',
    element: <SubscriptionsPage />,
  },
  {
    path: 'subscriptions/:subId',
    element: <SubscriptionPage />,
  },
  {
    path: 'calculator',
    element: <Calculator />,
  },
  {
    path: '*',
    element: <Page404 />,
  },
])

const RouterProvider = ({ children }) => {
  return <ReactRouterProvider router={router}>{children}</ReactRouterProvider>
}

export default RouterProvider
